export default __webpack_public_path__ + "static/media/angbao-bonus.91da82ce.webp";